export enum SettingsType {
    ToolManagementGroupEmail = 0,
    XlsxReportPath = 1,
    ToolScanOnServiceReturn = 2,
    Tmg9CljPassword = 3,
    TicketTimeThresholdLow = 4,
    TicketTimeThresholdMedium = 5,
    TicketTimeThresholdHigh = 6,
    TicketTimeThresholdUrgent = 7,
    ValidateRoleOnTicketTaskClose = 8
}
